import axios from "axios";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";

/*** Queries **********************/
const _fetcher = ( baseUrl, productsId = null) => {
    const uri = productsId ? `/${productsId}` : "";
        return axios.get(`${baseUrl}${uri}`)
        .then((res) => {
        return res.data;
    });
};

export const useProductsQuery = (productsId = null, fetcher = _fetcher) => {
    return useQuery(
        ['products', productsId],
        () => fetcher(productsId ? '/api/protected/products' : '/api/products', productsId),
        {refetchInterval: 10000})
}
export const useProductsCentersQuery = ({productsId, fetcher = _fetcher, queryOptions = {}}) => {
    return useQuery(
        ['products-center'],
        () => fetcher('/api/protected/products/'+productsId+'/centers'),
        {refetchInterval: 10000, ...queryOptions})

}

/*** Mutations **********************/

export const createProductsMutation = (param) => {
    return axios.post(`/api/protected/products`, param)
        .then(res => res)
}

export const useCreateProductsMutation = (mutator = createProductsMutation) => {
    const queryClient = useQueryClient()
    return useMutation(
        ['create-products'],
        (params) => mutator(params),
        {onSuccess: () => queryClient.invalidateQueries(["products"])}
    );
}
export const updateProductsMutation = ([id, params]) => {
    return axios.put(`/api/protected/products/${ id }`, params)
        .then(res => res);
};

export const useUpdateProductsMutation = (mutator = updateProductsMutation) => {
    const queryClient = useQueryClient();
    return useMutation(
        ['update-products'],
        (params) => mutator(params),
        {onSuccess: () => queryClient.invalidateQueries(["products"])}
    );
};
export const updateVisibilityProductMutation= ([id, params]) => {
    return axios.put(`/api/protected/products/${ id }/visibility`, params)
        .then(res => res);
};
export const useUpdateVisibilityProductMutation = (mutator = updateVisibilityProductMutation) => {
    const queryClient = useQueryClient();
    return useMutation(
        ['update-products'],
        (params) => mutator(params),
        {onSuccess: () => queryClient.invalidateQueries(["products"])}
    );
};

export  const createCenterAssociatedProductMutation = ([id, params]) => {
    return axios.post(`/api/protected/products/${ id }/centers`, params)
        .then(res => res);
};

export const useCreateCenterAssociatedProductMutation = (mutator = createCenterAssociatedProductMutation) => {
    const queryClient = useQueryClient();
    return useMutation(
        ['update-products'],
        (params) => mutator(params),
        {onSuccess: () => queryClient.invalidateQueries(["products"])}
    );
};

export const deleteCenterAssociatedProductMutation= ([id, params]) => {
    return axios.delete(`/api/protected/products/${ id }/centers`, {data: params})
        .then(res => res);
};

export const useDeleteCenterAssociatedProductMutation = (mutator = deleteCenterAssociatedProductMutation) => {
    const queryClient = useQueryClient();
    return useMutation(
        ['update-products'],
        (params) => mutator(params),
        {onSuccess: () => queryClient.invalidateQueries(["products"])}
    );
};

export  const updateCenterAssociatedProductMutation = ([id, params]) => {
    return axios.put(`/api/protected/products/${ id }/centers`, params)
        .then(res => res);
};
export const useUpdateCenterAssociatedProductMutation = (mutator = updateCenterAssociatedProductMutation) => {
    const queryClient = useQueryClient();
    return useMutation(
        ['update-products'],
        (params) => mutator(params),
        {onSuccess: () => queryClient.invalidateQueries(["products"])}
    );
};